import type { AnonymousConversationMutationData } from '@mote/api'
import { AnonymousExpiredMoteStatus } from './AnonymousExpiredMoteStatus'

export const anonymousConversationMutationData: AnonymousConversationMutationData =
  {
    moteStatus: new AnonymousExpiredMoteStatus(),
    auth: { isLoggedIn: false },
    conversation: { currentMoteId: '', replyMoteStatuses: [], canReply: false },
    device: {
      key: '',
      assistiveCarousel: [],
      affirmativeCarousel: [],
      recommendedTranscriptionLocale: '',
      recommendedUXLocale: ''
    }
  }
